import React from 'react'

const Contact = () => {
  return (
    <>
      <div className='mainContact'>
      <div className='serviceText'>
            <h4>Contact Us</h4>
            <h2>Contact us the get started</h2>
            <div>
            
            </div>
        </div>

        <div className='contactdetails'>
            <div className='contactinfo'>
                <div className='contactlogo'>
                    <div className='contactIcon'><i className="fa fa-leanpub"></i></div>
                    <div className='contactData'>
                        <h2>Location:</h2>
                        <p>A108 Adam Street, New York, NY 535022</p>
                    </div>
                </div>
                <div className='contactlogo'>
                    <div className='contactIcon'><i className="fa fa-leanpub"></i></div>
                    <div className='contactData'>
                        <h2>Email:</h2>
                        <p>info@example.com</p>
                    </div>
                </div>
                <div className='contactlogo'>
                    <div className='contactIcon'><i className="fa fa-leanpub"></i></div>
                    <div className='contactData'>
                        <h2>Call:</h2>
                        <p>+1 5589 55488 55s</p>
                    </div>
                </div>
                <div>
                <iframe className='fromMap' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14429.417386204388!2d89.0083715!3d25.292296199999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39fcbdfddf6f1a79%3A0xe9f28842e90c9f97!2zMjXCsDE3JzExLjMiTiA4OcKwMDAnNTkuNSJF!5e0!3m2!1sbn!2sbd!4v1650401259057!5m2!1sbn!2sbd" style={{"border":0,'height':"25rem"}} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" title='shs'></iframe>
                </div>
            </div>

            <div className='fromMargin'>
                
            </div>

            <div className='contactForm'>
            <div className='formINput'>
                <div>
                    <label htmlFor="">Your Name</label><br />
                    <input type="text" placeholder='Input Your Name' />
                </div>
                <div>
                    <label htmlFor="">Your Email</label><br />
                    <input type="text" placeholder='Input Your Email' />
                </div>
            </div>
            <div className='contactSubject'>
                <label htmlFor="">Subject</label><br />
                <input type="text" placeholder='Input Your Subject' />
            </div>

            <div className='contactSubject'>
                <label htmlFor="">Massage</label><br />
                <textarea type="text" rows='10' cols='50' placeholder='Input Your Subject' /><br />
                <button className='fromButton'>Send</button>
            </div>
        </div>
        </div>

        
      </div>
    </>
  )
}

export default Contact
